export default {
	primary: '#08105B',
	secondary: '#113FD6',
	accent: '#1976D2',
	error: '#f44336',
	warning: '#FFF176',
	info: '#00E5FF',
	success: '#00E676'
}
